import { render } from "./AppSavePopup.vue?vue&type=template&id=1f0d0688"
import script from "./AppSavePopup.vue?vue&type=script&lang=js"
export * from "./AppSavePopup.vue?vue&type=script&lang=js"

import "./AppSavePopup.vue?vue&type=style&index=0&id=1f0d0688&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\45\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__